import * as React from "react";
import { OldProgressBarQuestionnaireSectionUnconnected } from "@teamprevent/common/questionnaires/components/OldProgressBarQuestionnaireSection";
import { getQuestionConfig } from "@teamprevent/common/questionnaires/questionnaireConfig";

import { connect } from "react-redux";
import { mapDispatchToQuestionnaireSectionProps, makeMapStateToQuestionnaireSectionProps } from "@teamprevent/common/questionnaires/mappers";
import { CustomQuestionsQuestionnaireSectionProps } from "@teamprevent/common/questionnaires/QuestionnaireSectionProps";
import { TextQuestion } from "@teamprevent/common/questionnaires/components/questions/TextQuestion";
import { DropdownQuestion } from "@teamprevent/common/questionnaires/components/questions/DropdownQuestion";
import { getAnswerToQuestionWithId } from "@teamprevent/common/questionnaires/getAnswerToQuestionWithId";
import { values } from "lodash";

import { YesNoWithFollowUpQuestion } from "@teamprevent/common/questionnaires/components/questions/YesNoWithFollowUpQuestion";

import { MultiButtonQuestion } from "@teamprevent/common/questionnaires/components/questions/MultiButtonQuestion";

import * as questionIds from "../consultationQuestions/questionIds";
import { sections } from "../consultation";

const HealthSurveillanceConsultationBiologicalMonitoringSectionUnconnected: React.FunctionComponent<CustomQuestionsQuestionnaireSectionProps> =
    (props: CustomQuestionsQuestionnaireSectionProps) => {

        const questions = values(props.questions || {});

        return (
            <OldProgressBarQuestionnaireSectionUnconnected
                {...props}
                {...sections.BiologicalMonitoring}
            >
                {YesNoWithFollowUpQuestion({
                    readonly: props.readonly,
                    questionConfigs: [
                        getQuestionConfig(props.questionConfigs, questionIds.BiologicalMonitoringUnableToCarryOut),
                        getQuestionConfig(props.questionConfigs, questionIds.BiologicalMonitoringUnableToCarryOutReason)
                    ],
                    mandatory: true,
                    followUpMandatory: true,
                    questions: props.questions
                })}
                {getAnswerToQuestionWithId(questions, questionIds.BiologicalMonitoringUnableToCarryOut) !== MultiButtonQuestion.YesOption && <>
                    <DropdownQuestion
                        readonly={props.readonly}
                        questionConfig={getQuestionConfig(props.questionConfigs, questionIds.BiologicalMonitoringSampleTaken)}
                        options={[
                            { text: "Blood", value: "Blood" },
                            { text: "Urine", value: "Urine" },
                            { text: "Other", value: "Other" }
                        ]}
                        mandatory
                    />
                    {getAnswerToQuestionWithId(questions, questionIds.BiologicalMonitoringSampleTaken) === "Other" &&
                    <TextQuestion
                        readonly={props.readonly}
                        questionConfig={getQuestionConfig(props.questionConfigs, questionIds.BiologicalMonitoringSampleTakenOtherDetails)}
                        mandatory
                    />
                    }
                    <TextQuestion
                        readonly={props.readonly}
                        questionConfig={getQuestionConfig(props.questionConfigs, questionIds.BiologicalMonitoringSubstancesBeingTestedFor)}
                        mandatory
                    />
                    <TextQuestion
                        readonly={props.readonly}
                        questionConfig={getQuestionConfig(props.questionConfigs, questionIds.BiologicalMonitoringLaboratorySentTo)}
                        mandatory
                    />
                    <TextQuestion
                        readonly={props.readonly}
                        questionConfig={getQuestionConfig(props.questionConfigs, questionIds.BiologicalMonitoringClinicalNotes)}
                        mandatory
                        multiline
                    />
                </>}
            </OldProgressBarQuestionnaireSectionUnconnected>
        );
    };

export const HealthSurveillanceConsultationBiologicalMonitoringSection = connect(
    makeMapStateToQuestionnaireSectionProps(sections.BiologicalMonitoring.id),
    mapDispatchToQuestionnaireSectionProps
)(HealthSurveillanceConsultationBiologicalMonitoringSectionUnconnected);
